document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('subscribe-form');
  const message = document.getElementById('subscribe-message');

  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const emailInput = form.querySelector('input[name="email"]');
      const email = emailInput.value.trim();

      if (!email) {
        message.textContent = 'Please enter a valid email address.';
        message.style.color = 'red';
        return;
      }

      message.textContent = 'Subscribing...';
      message.style.color = '#555';

      try {
        const formData = new FormData();
        formData.append('action', 'swtheme_subscribe');
        formData.append('email', email);

        const response = await fetch('/wp-admin/admin-ajax.php', {
          method: 'POST',
          body: formData
        });

        const result = await response.json();

        if (result.success) {
          message.textContent = 'Successfully subscribed!';
          message.style.color = 'green';
          form.reset();
        } else {
          message.textContent = result.data?.message || 'There was an error. Please try again.';
          message.style.color = 'red';
        }
      } catch (error) {
        console.error('Error subscribing:', error);
        message.textContent = 'There was an error. Please try again.';
        message.style.color = 'red';
      }
    });
  }
});

